module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.71394c0c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Pe-icon-7-stroke.eot
// module id = 2745
// module chunks = 33